import CommercialServicePage from "@/components/commercial-service-page";
import {
  commercialServicePages,
  getCommercialServicePage,
} from "@/constants/commercial-service-pages";

export default function CommercialServiceRoute({ slug }) {
  const page = getCommercialServicePage(slug);

  if (!page) return null;

  return <CommercialServicePage page={page} />;
}

export function getStaticPaths() {
  return {
    paths: commercialServicePages.map((page) => ({
      params: { commercialService: page.slug },
    })),
    fallback: false,
  };
}

export function getStaticProps({ params }) {
  const page = getCommercialServicePage(params.commercialService);

  if (!page) return { notFound: true };

  return {
    props: { slug: page.slug },
  };
}

CommercialServiceRoute.serviceTheme = "blue";

CommercialServiceRoute.usesServiceTemplate = true;
